// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xbhB7","left":"styles_left__fdPiq","desktopActions":"styles_desktopActions__3TQq6","title":"styles_title__mzYN2"};